import React from 'react';
import { Field } from 'formik';
import { Row, Col, FormGroup, Input, Label, FormFeedback } from 'reactstrap';
import * as dataSeed from '../shared/DataSeed';

export const DataTambahan = ({ errors, touched, values, state, props, onValueChange, setFieldValue, handleChange, handleBlur, onHaveAccountsInOtherBank }) => (
    <React.Fragment>
        <FormGroup tag="fieldset">
            <legend>Data Tambahan</legend>
            <Row>
                {/*<Col md="4">*/}
                {/*    <FormGroup>*/}
                {/*        <Label>Pendidikan Terakhir<span className="text-danger">*</span></Label>*/}
                {/*        <Field className={errors.EducationId && touched.EducationId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}*/}
                {/*            component="select" name="EducationId">*/}
                {/*            <option value="">-- Pilih --</option>*/}
                {/*            {dataSeed.educations.map((data, index) =>*/}
                {/*                <option value={data.id} key={index}>{data.name}</option>*/}
                {/*            )}*/}
                {/*        </Field>*/}
                {/*        {errors.EducationId && touched.EducationId ? (*/}
                {/*            <FormFeedback>{errors.EducationId}</FormFeedback>*/}
                {/*        ) : null}*/}
                {/*    </FormGroup>*/}
                {/*</Col>*/}
            </Row>
            <Row>

                <Col md="4">
                    <FormGroup>
                        <Label>Memiliki Rekening/Kartu Kredit Di Bank/Institusi Lain<span className="text-danger">*</span></Label>
                        <Field component="select" name="HaveAccountsInOtherBank"
                            onKeyUp={(e) => onHaveAccountsInOtherBank(e, setFieldValue)}
                            className={errors.HaveAccountsInOtherBank && touched.HaveAccountsInOtherBank ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}>
                            {/*<option value="">-- Pilih --</option>*/}
                            {dataSeed.yesOrNo.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.HaveAccountsInOtherBank && touched.HaveAccountsInOtherBank ? (
                            <FormFeedback>{errors.HaveAccountsInOtherBank}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Nama Bank/Institusi<span className="text-danger">*</span></Label>
                        <Input tag={Field} name="OtherBankOrInstitutionName" id="OtherBankOrInstitutionName" type="text" bsSize="sm"
                            disabled={values.HaveAccountsInOtherBank !== "1"}
                            invalid={errors.OtherBankOrInstitutionName && touched.OtherBankOrInstitutionName} />
                        {errors.OtherBankOrInstitutionName && touched.OtherBankOrInstitutionName ? (
                            <FormFeedback>{errors.OtherBankOrInstitutionName}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>Lama Kepemilikan Di Bank/Institusi Lain (YYYY-MM)<span className="text-danger">*</span></Label>
                        <Field component="input" name="LongOwnershipInOtherBankOrInstitutionYear" type="month"
                            disabled={values.HaveAccountsInOtherBank !== "1"}
                            className={errors.LongOwnershipInOtherBankOrInstitutionYear && touched.LongOwnershipInOtherBankOrInstitutionYear ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}>
                        </Field>
                        {errors.LongOwnershipInOtherBankOrInstitutionYear && touched.LongOwnershipInOtherBankOrInstitutionYear ? (
                            <FormFeedback>{errors.LongOwnershipInOtherBankOrInstitutionYear}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Memiliki Hubungan Usaha Dengan Luar Negeri<span className="text-danger">*</span></Label>
                        <Field component="select" name="HaveBusinessRelationsWithOverseas"
                            className={errors.HaveBusinessRelationsWithOverseas && touched.HaveBusinessRelationsWithOverseas ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}>
                            {/*<option value="">-- Pilih --</option>*/}
                            {dataSeed.yesOrNo.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.HaveBusinessRelationsWithOverseas && touched.HaveBusinessRelationsWithOverseas ? (
                            <FormFeedback>{errors.HaveBusinessRelationsWithOverseas}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>

                {(values.HaveBusinessRelationsWithOverseas === "1") ?
                    <Col md="4">
                        <FormGroup>
                            <Label>Nama Negara Tempat Hubungan Usaha</Label>
                            <Field component="select" name="BusinessRelationsCountryName"
                                disabled={values.HaveBusinessRelationsWithOverseas === "2"}
                                className={errors.BusinessRelationsCountryName && touched.BusinessRelationsCountryName ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}>
                                {/*<option value="">-- Pilih --</option>*/}
                                {dataSeed.countries.map((data, index) =>
                                    <option value={data.id} key={index}>{data.name}</option>
                                )}
                            </Field>
                            {errors.BusinessRelationsCountryName && touched.BusinessRelationsCountryName ? (
                                <FormFeedback>{errors.BusinessRelationsCountryName}</FormFeedback>
                            ) : null}
                        </FormGroup>
                    </Col>
                    : null}

                <Col md="4">
                    <FormGroup>
                        <Label>Sumber Kekayaan Warisan<span className="text-danger">*</span></Label>
                        <Field component="select" name="SourceOfInheritance"
                            className={errors.SourceOfInheritance && touched.SourceOfInheritance ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}>
                            {/*<option value="">-- Pilih --</option>*/}
                            {dataSeed.yesOrNo.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.SourceOfInheritance && touched.SourceOfInheritance ? (
                            <FormFeedback>{errors.SourceOfInheritance}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>Sumber Kekayaan Tabungan<span className="text-danger">*</span></Label>
                        <Field component="select" name="SourceOfSavings"
                            className={errors.SourceOfSavings && touched.SourceOfSavings ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}>
                            {/*<option value="">-- Pilih --</option>*/}
                            {dataSeed.yesOrNo.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.SourceOfSavings && touched.SourceOfSavings ? (
                            <FormFeedback>{errors.SourceOfSavings}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Sumber Kekayaan Hasil Usaha<span className="text-danger">*</span></Label>
                        <Field component="select" name="SourceOfBusiness"
                            className={errors.SourceOfBusiness && touched.SourceOfBusiness ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}>
                            {/*<option value="">-- Pilih --</option>*/}
                            {dataSeed.yesOrNo.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.SourceOfBusiness && touched.SourceOfBusiness ? (
                            <FormFeedback>{errors.SourceOfBusiness}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Sumber Kekayaan Hibah/Hadiah<span className="text-danger">*</span></Label>
                        <Field component="select" name="SourceOfGrantOrGift"
                            className={errors.SourceOfGrantOrGift && touched.SourceOfGrantOrGift ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}>
                            {/*<option value="">-- Pilih --</option>*/}
                            {dataSeed.yesOrNo.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.SourceOfGrantOrGift && touched.SourceOfGrantOrGift ? (
                            <FormFeedback>{errors.SourceOfGrantOrGift}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>Sumber Kekayaan Gaji<span className="text-danger">*</span></Label>
                        <Field component="select" name="SourceOfSalary"
                            className={errors.SourceOfSalary && touched.SourceOfSalary ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}>
                            {/*<option value="">-- Pilih --</option>*/}
                            {dataSeed.yesOrNo.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.SourceOfSalary && touched.SourceOfSalary ? (
                            <FormFeedback>{errors.SourceOfSalary}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Sumber Kekayaan Lainnya<span className="text-danger">*</span></Label>
                        <Input tag={Field} name="SourceOfOther" id="SourceOfOther" type="number" bsSize="sm"
                            inputMode="numeric"
                            onKeyDown={(e) => {
                                // Allow: backspace, delete, tab, escape, enter, arrows
                                if (['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) {
                                    return;
                                }
                                // Block non-numeric characters (including e, +, -, .)
                                if (e.key < '0' || e.key > '9') {
                                    e.preventDefault();
                                }
                            }}
                            className={errors.SourceOfOther && touched.SourceOfOther ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'} />
                        {errors.SourceOfOther && touched.SourceOfOther ? (
                            <FormFeedback>{errors.SourceOfOther}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
        </FormGroup>
    </React.Fragment>
);


// WEBPACK FOOTER //
// ./src/components/DataTambahan.js